export class AccountingJournalReportFilter  {
    journalId: string;
    accountingMonthId: string;
    legalEntityId: string;
    journalType?: number;
    printOption?: number;
    legalEntityGroup?: boolean;
    periodGroup?: boolean;
    accountsReceivingTypeGroup?: boolean;
    serviceCodeGroup?: boolean;
    toExport?: boolean;
    accountingLotNumber?: string;
    accountingLot?: string;

    constructor(param: any) {
    this.journalId= param.journalId;
    this.accountingMonthId= param.accountingMonthId;
    this.legalEntityId= param.legalEntityId;
    this.journalType=param.journalType;
    this.printOption=param.printOption;
    this.legalEntityGroup=param.legalEntityGroup;
    this.periodGroup=param.periodGroup;
    this.accountsReceivingTypeGroup= param.accountsReceivingTypeGroup;
    this.serviceCodeGroup= param.serviceCodeGroup;
    this.toExport= param.toExport;
    this.accountingLotNumber=param.accountingLotNumber;
    this.accountingLot= param.accountingLot;
    }
}
